import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PaymentStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  
  selector: 'cradua-paymentstatus-container',
  templateUrl: './paymentstatus-container.component.html',
  styleUrls: ['./paymentstatus-container.component.scss']
})
export class PaymentstatusContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  paymentstatuss$: Observable<PaymentStatusDto[]>;
  loading: boolean;
  isLoadingPaymentStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingPaymentStatus$ = this.gatwayFacade.isLoadingGateway("PaymentStatus");
    this.paymentstatuss$ = this.gatwayFacade.loadGateway("PaymentStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePaymentStatus(deletedValue: any) {
    this.gatwayFacade.remove("PaymentStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitPaymentStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.PaymentStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllPaymentStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllPaymentStatus.push(pullData[i]);
    }
  }

// check if the addAllPaymentStatus array is not empty, then dispatch the data to the store
   if(addAllPaymentStatus.length > 0) {
    this.gatwayFacade.add('PaymentStatus', addAllPaymentStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('PaymentStatus', allUpdates, ['id']);
  }

   }


}


